import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getConfig = () => axios.get(`${API}/config`).then((r) => r.data);

export const createEnquiry = (payload) =>
  axios.post(`${API}/enquiries`, payload).then((r) => r.data);

export const updateEnquiry = (id, data, current_step) =>
  axios.put(`${API}/enquiries/${id}`, { data, current_step }).then((r) => r.data);

export const submitEnquiry = (id) =>
  axios.post(`${API}/enquiries/${id}/submit`).then((r) => r.data);

export const completeLinked = (id, data) =>
  axios.post(`${API}/enquiries/${id}/complete-linked`, { data }).then((r) => r.data);

export const resumeEnquiry = (token) =>
  axios.get(`${API}/enquiries/resume/${token}`).then((r) => r.data);

export const selectRoute = (id, data) =>
  axios.post(`${API}/enquiries/${id}/select-route`, { data }).then((r) => r.data);

export const saveAndReturn = (id, email) =>
  axios.post(`${API}/enquiries/${id}/save-and-return`, { email }).then((r) => r.data);

export const sendUrgentContact = (payload) =>
  axios.post(`${API}/urgent-contact`, payload).then((r) => r.data);

export const sendMediationReferral = (payload) =>
  axios.post(`${API}/mediation-referral`, payload).then((r) => r.data);

export const getEmailTemplates = () => axios.get(`${API}/email-templates`, { withCredentials: true }).then((r) => r.data);

export const saveEmailTemplates = (templates) =>
  axios.put(`${API}/email-templates`, { templates }, { withCredentials: true }).then((r) => r.data);

export const authLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true }).then((r) => r.data);
export const authLogout = () => axios.post(`${API}/auth/logout`, {}, { withCredentials: true }).then((r) => r.data);
export const authMe = () => axios.get(`${API}/auth/me`, { withCredentials: true }).then((r) => r.data);
export const authForgot = (email) =>
  axios.post(`${API}/auth/forgot-password`, { email }, { withCredentials: true }).then((r) => r.data);
export const authReset = (token, password) =>
  axios.post(`${API}/auth/reset-password`, { token, password }, { withCredentials: true }).then((r) => r.data);
export const adminListEnquiries = (params) =>
  axios.get(`${API}/admin/enquiries`, { params, withCredentials: true }).then((r) => r.data);
export const adminChatLeads = (status) =>
  axios.get(`${API}/admin/chat-leads`, { params: { status }, withCredentials: true }).then((r) => r.data);
export const adminChatLeadFollowUp = (sessionId, followed, note = "") =>
  axios.post(`${API}/admin/chat-leads/${sessionId}/follow-up`, { followed, note }, { withCredentials: true }).then((r) => r.data);
export const adminNoFundingStats = () =>
  axios.get(`${API}/admin/no-funding-stats`, { withCredentials: true }).then((r) => r.data);
export const trackNoFundingClose = (source) =>
  fetch(`${API}/events/no-funding-close`, {
    method: "POST", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ source }),
  }).catch(() => {});
export const adminGetEnquiry = (id) =>
  axios.get(`${API}/admin/enquiries/${id}`, { withCredentials: true }).then((r) => r.data);
export const adminExportEnquiries = (params) =>
  axios.get(`${API}/admin/enquiries/export`, { params, withCredentials: true, responseType: "blob" }).then((r) => r.data);

export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const fileUrl = (id) => `${API}/files/${id}`;

export const getAppointmentSlots = (id) =>
  axios.get(`${API}/enquiries/${id}/appointment-slots`).then((r) => r.data);

export const bookAppointment = (id, payload) =>
  axios.post(`${API}/enquiries/${id}/book-appointment`, payload).then((r) => r.data);
